//開発版
// import Vue from "vue/dist/vue.esm.js";
//本番用
import Vue from "vue/dist/vue.min.js";

const host = window.location.host;

const ROOT_DIR = host.includes("nishinippon") ? "nsp/judo/kinshu" : "kinshu";
const ROOT_URL = "https://kingyoku-nes.jp/wp-json/wp/v2/kinshuki";

new Vue({
  el: ".p-topicsArea",
  data: {
    resultData: [],
    topNewsCount: 4,
    newsData: [],
    newsCount: 12,
    newsCountValue: 4,
  },
  methods: {
    newsAnchorClickable(bool) {
      return (bool && {}) || { "pointer-events": "none", cursor: "inherit" };
    },
    addNewsCount() {
      console.log(this.resultData);
      this.newsCount += this.newsCountValue;
    },
  },

  computed: {
    listData() {
      return this.resultData.map((data) => {
        const { id, acf } = data;
        const title = data.title.rendered;
        const content = data.content.rendered;
        const thumbnail =
          (acf && acf.image && acf.image.sizes.large) ||
          "./assets/img/common/topics_ph2.jpg";
        let date = (data.date && new Date(data.date)) || "";
        let listLink = "";
        let target = "_self";
        let anchorFlg = true;

        if (acf.redirect_url != "") {
          listLink = acf.redirect_url;
          target = "_blank";
        } else if (acf.pdf) {
          listLink = acf.pdf.url;
          target = "_blank";
        } else {
          listLink = `/${ROOT_DIR}/news/detail/?article=${id}`;

          if (!content) {
            anchorFlg = false;
          }
        }

        date =
          (date &&
            `${date.getFullYear()}.${date.getMonth() + 1}.${date.getDate()}`) ||
          "";

        return { title, content, listLink, target, date, anchorFlg, thumbnail };
      });
    },
    limitedListData() {
      return this.listData.slice(0, this.topNewsCount);
    },
    limitedResultData() {
      return this.listData.slice(0, this.newsCount);
    },
    news() {
      const data = this.newsData;
      const title = data.title && data.title.rendered;
      let date = (data.date && new Date(data.date)) || "";
      const content = data.content && data.content.rendered;

      date =
        (date &&
          `${date.getFullYear()}.${date.getMonth() + 1}.${date.getDate()}`) ||
        "";
      document.title = title || "金鷲旗高校柔道大会【公式サイト】";
      const datatitle = title + ' || ' + '新着情報' + ' || ' + '金鷲旗高校柔道大会【公式サイト】';
      //GTMへVueでのページタイトルを送信
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "page_view",
        page_title: datatitle,
      });

      return { title, date, content };
    },
  },

  async created() {
    if (window.location.pathname.includes(`${ROOT_DIR}/news/detail/`)) {
      let params = new URLSearchParams(location.search);
      const news_id = params.get("article");

      const news_url = `${ROOT_URL}/${news_id}`;

      // if(!news_id) {
      //     window.location.href = `https://specials.nishinippon.co.jp/nsp/judo/kinshu/`;
      //     return;
      // }
      await fetch(news_url)
        .then((r) =>
          r.json().then((data) => ({ status: r.status, body: data }))
        )
        .then((res) => {
          if (res.status == 200) {
            this.newsData = res.body;
          }
          // else {
          //   window.location.href = `https://specials.nishinippon.co.jp/nsp/judo/kinshu/`;
          // }
          return this.newsData;
        });
    } else if (window.location.pathname.includes(ROOT_DIR)) {
      await fetch(ROOT_URL)
        .then((r) =>
          r.json().then((data) => ({ status: r.status, body: data }))
        )
        .then((res) => {
          if (res.status == 200) {
            this.resultData = res.body;
          }
          return this.resultData;
        });
    }
  },
});
